import React, { useState } from "react";
import { Form, Input, Select, Button, message } from "antd";
import axios from "axios";
import contactIcon1 from "../../images/home/iconMain.png";
import contactIcon2 from "../../images/contactus/contactIcon2.png";
import contactIcon3 from "../../images/contactus/contactIcon3.svg";
import contactIcon4 from "../../images/contactus/contactIcon4.png";

const ContactForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Extract country code from phone
      const phoneValue = values.phone;
      const countryCode = phoneValue.startsWith('+') ? phoneValue.substring(0, 3) : '+91';
      const phoneNumber = phoneValue.replace(countryCode, '').replace(/\D/g, '');
      
      const formData = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        phone: `${countryCode}${phoneNumber}`,
        message: values.message
      };

      console.log("Sending form data:", formData);

      const response = await axios.post('/api/contact', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 10000, // 10 second timeout
      });

      if (response.data.success) {
        message.success(response.data.message);
        form.resetFields();
      } else {
        message.error(response.data.message || 'Failed to send message');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      
      if (error.response) {
        // Server responded with error
        message.error(error.response.data.message || 'Failed to send message');
      } else if (error.request) {
        // Request was made but no response received
        message.error('Unable to connect to server. Please try again later.');
      } else {
        // Something else happened
        message.error('An unexpected error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="my-20">
      <div
        className=" p-6 bg-[#FFFFFF] shadow-lg rounded-2xl my-20 mx-10 md:h-[570px]"
        style={{ maxWidth: "1440px", margin: "auto" }}
      >
        <div className=" md:flex gap-6">
          {/* Left Contact Info Section */}
          <div className="bg-gradient-to-br from-gray-100 to-green-100 max-w-[600px] md:h-[500px]  p-6 rounded-xl">
            <h2 className="text-[34px] font-black text-[#0A0A0A] mt-6">
              Contact Information
            </h2>
            <p className="text-[22px] poppins-regular text-[#0A0A0A] mt-4">
              Let's Discuss
            </p>
            <p className="text-lg poppins-medium text-[#37517E] mt-4">
              After completing the form, our team will contact you <br /> within
              24 hours.
            </p>

            <div className="mt-8 space-y-6 text-base poppins-medium text-[#121212]">
              <p className="flex items-center gap-4">
                <img src={contactIcon1} alt="contact1" />
                +919586900007
              </p>
              <p className="flex items-center gap-4">
                <img src={contactIcon2} alt="contact2" />
                Una - Talala Road, Harmaria
              </p>
              <p className="flex items-center gap-4">
                <img src={contactIcon3} alt="contact3" />
                www.girglades.com
              </p>
              <p className="flex items-center gap-4">
                <img src={contactIcon4} alt="contact4" />
                hello@girglades.com
              </p>
            </div>
          </div>

          {/* Right Contact Form */}
          <div className="md:max-w-[600px] max-md:mt-4">
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              className="space-y-2 "
            >
              {/* Title, First Name, Last Name */}
              <div className="flex  gap-2">
                <Form.Item
                  name="firstName"
                  label={
                    <span className="text-[15px] poppins-regular">
                      First Name
                    </span>
                  }
                  className="col-span-4"
                  rules={[{ required: true, message: "Enter First Name" }]}
                >
                  <Input
                    placeholder="Enter First Name"
                    className="text-[15px] poppins-regular"
                  />
                </Form.Item>
                <Form.Item
                  name="lastName"
                  label={
                    <span className="text-[15px] poppins-regular">
                      Last Name
                    </span>
                  }
                  className="col-span-4"
                  rules={[{ required: true, message: "Enter Last Name" }]}
                >
                  <Input
                    placeholder="Enter Last Name"
                    className="text-[15px] poppins-regular"
                  />
                </Form.Item>
              </div>

              {/* Email Address */}
              <div className="mt-4">
                <Form.Item
                  name="email"
                  label={
                    <span className="text-[15px] poppins-regular">
                      Email Address
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Enter a valid email",
                    },
                  ]}
                >
                  <Input
                    placeholder="Yourname@gmail.com"
                    className="text-[15px] poppins-regular"
                  />
                </Form.Item>
              </div>
              <div className="mt-4">
                <Form.Item
                  label={
                    <span className="text-[15px] poppins-regular">
                      Mobile Number
                    </span>
                  }
                  name="phone"
                  rules={[{ required: true, message: "Enter Your Number" }]}
                >
                  <Input
                    addonBefore={
                      <Select defaultValue="91+" style={{ width: 80 }}>
                        <Select.Option value="91+">+91</Select.Option>
                        <Select.Option value="1+">+1</Select.Option>
                      </Select>
                    }
                    className="text-[15px] poppins-regular"
                    placeholder="Enter Your Number"
                  />
                </Form.Item>
              </div>

              {/* Message */}
              <Form.Item
                name="message"
                label={
                  <span className="text-[15px] poppins-regular">Message</span>
                }
                rules={[{ required: true, message: "Enter your message" }]}
              >
                <Input.TextArea
                  rows={3}
                  placeholder="Enter Your Message"
                  className="text-[15px] poppins-regular"
                />
              </Form.Item>

              {/* Submit Button */}
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  className="bg-[#672220] w-[173px] h-[50px] mt-6 text-xl poppins-medium rounded-[26px]"
                >
                  {loading ? 'Sending...' : 'Submit'}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
